module.exports = __webpack_public_path__ + "img/inventory.6d4c5428.png";